import React from 'react'
import BlockUi from 'react-block-ui'
import { lifecycle } from 'recompose'
import withLayout from '../../../layout/withLayout'
import CustomerHead from './CustomerHead'
import TabBasicData from './TabBasicData'
import TabMedical from './TabMedical'
import TabPhotos from './TabPhotos'
import TabAccounting from './TabAccounting'
import TabFiles from './TabFiles'
import TabComments from './TabComments'

const Customer = (props) => {
    const {customer, startProcessFetching} = props

    if (customer === null) {
        return null
    }

    return (
        <BlockUi blocking={startProcessFetching}>

            <CustomerHead {...props}/>

            <TabBasicData {...props}/>

            <TabMedical {...props}/>

            <TabPhotos {...props}/>

            <TabAccounting {...props}/>

            <TabFiles {...props}/>

            <TabComments {...props}/>

        </BlockUi>
    )
}


export default lifecycle({
    componentDidMount() {
        this.props.findCustomer(this.props.customerId)
    },
})(withLayout(Customer))



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/Customer.js